import styled from 'styled-components';
import { Input } from '../input';

export const Wrapper = styled.div`
    min-height: 90vh;
`;

export const Heading = styled.div`
    font-weight: bold;
    font-size: 18px;
`;

export const CustomInputWrapper = styled.div`
    // display: grid;
    grid-template-columns: 25px 1fr;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    margin: 20px auto;
    margin-top: 20px;

    @media (max-width: 700px) {
        height: 40px;
    }
`;

export const SearchIcon = styled.img`
    height: 25px;
    width: 25px;
    object-fit: scale-down;
`;

export const CustomInput = styled(Input)`
    border: none;
    margin: 0;
`;

export const ListItems = styled.div`
    padding: 16px;
    border-bottom: 1px solid #eee;
    cursor: pointer;

    &:hover {
        background: #eee;
        border-radius: 8px;
    }
`;

export const ItemsWrapper = styled.div`
    height: 330px;
    overflow: scroll;

    @media (max-width: 700px) {
        height: auto;
    }
`;

export const KilometreTabs = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 20px;
    gap: 10px;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    background: #f0f0f6;
    border-radius: 8px;
    flex: none;
    order: 0;
    flex-grow: 1;
    width: 140px;
`;

export const selectedTabs = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 20px;
    gap: 10px;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    background: #ebfbee;
    border: 1px solid #0fa457;
    border-radius: 8px;
    flex: none;
    order: 0;
    flex-grow: 1;
    width: 140px;
`;

export const KilometresWrapper = styled.div`
    gap: 20px;
    display: flex;
    flex-wrap: wrap;
    margin-top: 25px;
`;
